import api from '../../api';
import { Perfil } from '../../model/Usuario/Perfil';
import { Permissao } from '../../model/Usuario/Permissao';




interface ApiError {
    response?: {
        data: { message: string; };
        status: number;
    };
}

export class PerfilViewModel {
    static async obterPerfis(): Promise<Perfil[]> {
        try {
            const response = await api.get('/perfis');
            return response.data.map((perfil: any) => this.mapPerfil(perfil));
        } catch (error: unknown) {
            if (error instanceof Error) {
                const apiError = error as ApiError;
                throw new Error(apiError.response?.data.message || 'Erro ao obter perfis');
            }
            throw new Error('Erro desconhecido ao obter perfis');
        }
    }

    static async obterPerfisParaEditarUsuario(): Promise<Perfil[]> {
        try {
            const response = await api.get('/perfis/manual');
            return response.data.map((perfil: any) => this.mapPerfil(perfil));
        } catch (error: unknown) {
            if (error instanceof Error) {
                const apiError = error as ApiError;
                throw new Error(apiError.response?.data.message || 'Erro ao obter perfis');
            }
            throw new Error('Erro desconhecido ao obter perfis');
        }
    }

    static async criarPerfil(dados: Perfil): Promise<Perfil> {
        try {
            // Adaptar o payload para corresponder ao que a API espera
            const perfilPost = {
                nome: dados.nome,
                descricao: dados.descricao,
                permissoes: dados.permissoes.map(p => p.nome) // Adaptando para array de strings
            };

            const response = await api.post('/perfis', perfilPost);
            return this.mapPerfil(response.data);
        } catch (error: unknown) {
            if (error instanceof Error) {
                const apiError = error as ApiError;
                throw new Error(apiError.response?.data.message || 'Erro ao criar perfil');
            }
            throw new Error('Erro desconhecido ao criar perfil');
        }
    }


    static async atualizarPerfil(id: string, dados: Omit<Perfil, 'id'> & { permissoes: Permissao[] }): Promise<Perfil> {
        try {
            const perfilPut = {
                nome: dados.nome,
                descricao: dados.descricao,
                permissoes: dados.permissoes.map(p => p.nome)
            };

            const response = await api.put(`/perfis/${id}`, perfilPut);
            return this.mapPerfil(response.data);
        } catch (error: unknown) {
            if (error instanceof Error) {
                const apiError = error as ApiError;
                throw new Error(apiError.response?.data.message || 'Erro ao atualizar perfil');
            }
            throw new Error('Erro desconhecido ao atualizar perfil');
        }
    }

    static async obterPerfilPorId(id: string): Promise<Perfil> {
        try {
            const response = await api.get(`/perfis/${id}`);
            return this.mapPerfil(response.data);
        } catch (error: unknown) {
            if (error instanceof Error) {
                const apiError = error as ApiError;
                throw new Error(apiError.response?.data.message || 'Erro ao obter perfil');
            }
            throw new Error('Erro desconhecido ao obter perfil');
        }
    }

    private static mapPerfil(perfilData: any): Perfil {
        return {
            id: perfilData.id,
            nome: perfilData.nome,
            descricao: perfilData.descricao,
            permissoes: perfilData.permissoes.map((permissao: any) => ({
                id: permissao.id,
                nome: permissao.nome,
                descricao: permissao.descricao || '' // Caso não tenha descrição, fica vazio
            }))
        };
    }


}
